import { render, staticRenderFns } from "./icon-handler.vue?vue&type=template&id=44569ea4&scoped=true"
import script from "./icon-handler.vue?vue&type=script&lang=ts"
export * from "./icon-handler.vue?vue&type=script&lang=ts"
import style0 from "./icon-handler.vue?vue&type=style&index=0&id=44569ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44569ea4",
  null
  
)

export default component.exports